import styled from "styled-components";

const DailyObservationsDeliveryRoutePageStyled = styled.div`

`

export default DailyObservationsDeliveryRoutePageStyled;